import { DomSanitizer } from '@angular/platform-browser';
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-empty-list-message",
  templateUrl: "./empty-list-message.component.html",
  styleUrls: ["./empty-list-message.component.css"]
})
export class EmptyListMessageComponent implements OnInit {
  constructor(private domSanitizer: DomSanitizer) { }

  @Input()
  message: string;

  @Input()
  actionLabel: string;

  @Input()
  actionIcon: string;

  @Input()
  disabled: boolean;

  @Output()
  actionClick: EventEmitter<void> = new EventEmitter();

  @Input()
  actionHref?: string;

  ngOnInit() { }

  onActionClick() {
    this.actionClick.emit();
  }

  getVoidUrl() {
    return this.domSanitizer.bypassSecurityTrustUrl("javascript:void(0)");
  }
}
